// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"17":"6633540d","162":"6a84c1be","289":"44fe2da4","883":"897199a7","923":"190f0090"}[chunkId] + ".chunk.js";
};